import { render, staticRenderFns } from "./component-card.vue?vue&type=template&id=1e0cdea6&scoped=true&"
import script from "./component-card.vue?vue&type=script&lang=js&"
export * from "./component-card.vue?vue&type=script&lang=js&"
import style0 from "./component-card.vue?vue&type=style&index=0&id=1e0cdea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0cdea6",
  null
  
)

export default component.exports